import React from 'react';
import { ExtendedContentContainer } from 'components/ExtendedContent/ExtendedContentContainer';
import MarkerWithSound from 'components/MarkerWithSound';

export const MarkerWithSoundComponent = ({ src, audioInfo }) => {
    return (<ExtendedContentContainer  >
        <MarkerWithSound src={src} audioInfo={audioInfo} />
    </ExtendedContentContainer>)
};
